<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
  <div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
    <ol class="breadcrumb bc-3"  >
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Task Monitor </a>
      </li>
      
      </ol>
  <div class="inner-wrapper">
    <div class="sub-wrapper">
      <div class="col-lg-12 col-md-12 col-sm-12 middle-content no-padding">
        <h3 class="page-title obs-card-title" style="text-align:center">
          <span class="page-sub-title">
            <ng-container *ngIf="taskId > 0">Task {{taskId}}</ng-container>
            <ng-container *ngIf="taskId === 0">{{ 'TASK.TASK_CONFIGURATION' | translate }}</ng-container>
          </span><button *ngIf="taskId > 0" (click)="isNext ? onNextClick() : $event.preventDefault()"
            [ngClass]="isNext ? 'cursor-pointer':'disabled'" class="pull-right btn btn-primary primary-btn"><i
              class="fa fa-angle-right"></i>
            </button>
          <button *ngIf="taskId > 0"
            (click)="isPrevious ? onPreviousClick() : $event.preventDefault()"
            [ngClass]="isPrevious ? 'cursor-pointer':'disabled'" class="pull-right btn btn-primary primary-btn"><i
              class="fa fa-angle-left"></i>
          </button></h3>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
          <div class="section-wrapper">
            <p-toggleButton styleClass="pull-right" (onChange)="taskTurnOnOff()" onLabel="ON" offLabel="OFF" onIcon="fa-check" offIcon="fa-times"
              [(ngModel)]="Task.IsActive" [disabled]="taskId === 0"></p-toggleButton>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title">Unit <i class="fa fa-info-circle"
                pTooltip="Unit are enabled for interaction based on permission of User"></i> <span class="mandatory">*</span>
                
              </span>
                
                
            <p-tree [value]="unitTree" selectionMode="single" (onNodeSelect)="nodeSelected($event)"
              [(selection)]="selectedUnit" [styleClass]="disableTask ? 'disabled' : 'cursor-pointer'"></p-tree>
              <span class="section-Forerror" *ngIf="unitError">Kindly select Unit</span>
          </div>
          <div class="sub-section-wrapper" [hidden]="isEmployeeUnit">
            <span class="section-sub-title">Contract Number <span class="mandatory">*</span></span>
            <p-dropdown [options]="contracts"  placeholder="Select"  [(ngModel)]="selectedContractId" 
            [style]="{'width':'100%'}"
            (onChange)="checkHolder($event)" >
            
            </p-dropdown>
           
            <div *ngIf="isContractErrorMsg && !Task.ContractId">
            <span class="error-msg-colour">Please select Contract</span>
            <span class="error-msg-colour"
            *ngIf="!isHasContractDetails">Contract Holder is not available for this contract. Please contact admin to update these details. 
            </span>
            </div>
          </div>
          <div class="sub-section-wrapper" *ngIf="Task.TaskId === 0">
            <span class="section-sub-title">
              {{ 'TASK.MONITORING_MATRIX' | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-dropdown [options]="monitoringMatrixNames" placeholder="Select" [(ngModel)]="Task.MatrixId"
              (onChange)="getSectionData()" #matrixName="ngModel" required [disabled]="!Task.IsActive || disableTask">
            </p-dropdown>
            <span *ngIf="matrixName.errors && (matrixName.dirty || matrixName.touched) && !matrixName.valid"
              class="section-Forerror">{{ 'TASK.KINDLY_SELECT_MATRIX_NAME' | translate }}</span>
            <span *ngIf="matrixNameError" class="section-Forerror">{{ 'TASK.KINDLY_SELECT_MATRIX_NAME' | translate
              }}</span>
          </div>
          <div class="sub-section-wrapper" *ngIf="Task.TaskId > 0">
            <span class="section-sub-title">
              {{ 'TASK.MONITORING_MATRIX' | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-dropdown [options]="monitoringMatrixNames" [(ngModel)]="Task.MatrixId" #matrixName="ngModel" required
              (onChange)="getSectionData()" [disabled]="!Task.IsActive || disableTask">
            </p-dropdown>
            <span *ngIf="matrixName.errors && (matrixName.dirty || matrixName.touched) && !matrixName.valid"
              class="section-Forerror">{{ 'TASK.KINDLY_SELECT_MATRIX' | translate }}
            </span>
            <span *ngIf="matrixNameError" class="section-Forerror">{{ 'TASK.KINDLY_SELECT_MATRIX_NAME' | translate }}
            </span>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">Section
              <span class="mandatory">*</span>
            </span>
            <p-dropdown class="company-name-dropdown" [options]="taskList" [(ngModel)]="Task.SectionId"
              placeholder="Select" #sectionName="ngModel" required (onChange)="sectionSelected()"
              [disabled]="!Task.IsActive || disableTask"></p-dropdown>
            <span *ngIf="sectionName.errors && (sectionName.dirty || sectionName.touched) && !sectionName.valid"
              class="section-Forerror">{{ 'TASK.KINDLY_SELECT_SECTION' | translate }}</span>
            <span *ngIf="sectionNameError" class="section-Forerror">{{ 'TASK.KINDLY_SELECT_SECTION' | translate }}
            </span>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.NAME' | translate }}
              <span class="mandatory">*</span>
            </span>
            <ara-textarea [sourceText]="Task.Name" [maxLength]="1000" required
            (output)="getRemarks($event,'TaskNameText')"></ara-textarea>
            <span class="error-msg-colour"
            *ngIf="taskNameError" class="section-Forerror">{{ 'TASK.KINDLY_ENTER_TASK_NAME' | translate }}</span>
            <!-- <input type="text" class="form-control inputWidth" maxlength="50" [(ngModel)]="Task.Name" required
              [disabled]="!Task.IsActive || disableTask" #taskName="ngModel" /> -->
            <!-- <span class="section-Forerror"
              *ngIf="taskName.errors && (taskName.dirty || taskName.touched) && !taskName.valid">
              {{ 'TASK.KINDLY_ENTER_TASK_NAME' | translate }}

            </span> -->
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.DESCRIPTION' | translate }}
            </span>
            <ara-textarea [sourceText]="Task.TaskDescription" [maxLength]="1000" required rows="4" cols="30"
            (output)="getRemarks($event,'TaskDescriptionText')"></ara-textarea>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.RECURRING_TASK' | translate }}
              <span class="mandatory">*</span>
            </span>
            <div>
              <label class="radio-inline no-margin-top">
                <input type="radio" value="1" name="recurranceTaskR" [(ngModel)]="RecurrenceTask"
                  [disabled]="!Task.IsActive || disableTask" (click)="checkRecurrence()">Recurring</label>
              <label class="radio-inline no-margin-top">
                <input type="radio" value="2" name="recurranceTaskNR" [(ngModel)]="RecurrenceTask"
                  [disabled]="!Task.IsActive || disableTask" (click)="checkRecurrence()">Non-Recurring</label>
            </div>
          </div>
          <div class="sub-section-wrapper" *ngIf="RecurrenceTask==='1'">
            <span class="section-sub-title">
              {{ 'TASK.RECURRENCE_PERIOD' | translate }}
              <span class="mandatory">*</span>
            </span>
            <div>
              <label class="radio-inline no-margin-top">
                <input type="radio" value="Daily" name="recurrencePeriodD" [(ngModel)]="Task.RecurrencePeriod"
                  [disabled]="!Task.IsActive || disableTask" (click)="checkOccurrence($event)">Daily</label>

              <label class="radio-inline no-margin-top">
                <input type="radio" value="Weekly" name="recurrencePeriodW" [(ngModel)]="Task.RecurrencePeriod"
                  [disabled]="!Task.IsActive || disableTask" (click)="checkOccurrence($event)">Weekly</label>

              <label class="radio-inline no-margin-top">
                <input type="radio" value="Monthly" name="recurrencePeriodM" [(ngModel)]="Task.RecurrencePeriod"
                  [disabled]="!Task.IsActive || disableTask" (click)="checkOccurrence($event)"
                  [checked]="true">Monthly</label>

              <label class="radio-inline no-margin-top">
                <input type="radio" value="Quarterly" name="recurrencePeriodQ" [(ngModel)]="Task.RecurrencePeriod"
                  [disabled]="!Task.IsActive || disableTask" (click)="checkOccurrence($event)">Quarterly</label>
              <span class="section-Forerror" *ngIf="recurrencePeriodError">
                {{ 'TASK.KINDLY_SELECT_RECCURENCE_PERIOD' | translate }}
              </span>
            </div>
          </div>
          <div class="sub-section-wrapper" *ngIf="RecurrenceTask==='1'">
            <span class="section-sub-title">
              {{ 'TASK.MULTIPLIER' | translate }}
              <span class="mandatory">*</span>
            </span>
            <input type="number" class="form-control inputWidth" maxlength="50" [(ngModel)]="Task.Multiplier" required
              [disabled]="!isMultiplier" #prerequisiteName="ngModel" />
          </div>
          <div class="sub-section-wrapper" *ngIf="RecurrenceTask==='1' && dayNumberEnabled">
            <span class="section-sub-title">
              {{ 'TASK.DAY_NUMBER' | translate }}
              <span class="mandatory">*</span>
            </span>
            <input type="number" class="form-control inputWidth" [(ngModel)]="Task.DayNumber" required
              [disabled]="!Task.IsActive || disableTask" #prerequisiteName="ngModel" />
            <span class="section-Forerror" *ngIf="Task.DayNumber > maxDayNumber">
              <!-- Maximum allowed value is {{maxDayNumber}} -->
              Kindly Enter Day Number (Maximum {{maxDayNumber}})
            </span>
            <span class="section-Forerror" *ngIf="Task.DayNumber < 1">
              Kindly Enter Day Number Greater Than 0
              <!-- {{ 'TASK.MINIMUM_REQUIRED_VALUE_IS_1' | translate }} -->

            </span>
          </div>
          <div class="sub-section-wrapper" *ngIf="RecurrenceTask==='2'">
            <span class="section-sub-title">
              {{ 'TASK.DATE' | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-calendar [showIcon]="true" [(ngModel)]="dates" dateFormat="dd/mm/yy" selectionMode="multiple" monthNavigator="true"
              yearNavigator="true" yearRange="1950:2100" readonlyInput="true"
              [disabled]="!Task.IsActive || disableTask">
            </p-calendar>
            <div class="clearfix"></div>
            <span class="margin-top-10">{{ 'TASK.SELECTED_DATES' | translate }}</span>
            <ul>
              <li *ngFor="let date of dates">{{date | dateTimeFormat:'DD-MM-YYYY'}}</li>
            </ul>
            <span class="section-Forerror" *ngIf="!dates">
              {{ 'TASK.KINDLY_SELECT_NON_RECCURENCE_DATES' | translate }}</span>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.TASK_DOCUMENTS' | translate }}
            </span>
            <ara-file-upload [accept]="accept" [multiple]="multiple" [(inputFiles)]="Task.TaskFileDescription"
              [disabled]="!Task.IsActive || disableTask">
            </ara-file-upload>
            <ara-files-previewer [files]="taskDocuments"></ara-files-previewer>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.TASK_OWNER' | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-autoComplete class="auto-complete" [(ngModel)]="selectedUserEmp" [suggestions]="userResults"
              (completeMethod)="getUsersOnSearch($event)" (onSelect)="selectUser($event)"
              (onChange)="selectUser($event)" (onKeyUp)="resetPeoplePicker()" placeholder="Task Owner" field="FullName"
              [minLength]="1" appendTo="body" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
              [disabled]="!Task.IsActive || disableTask">
              <ng-template let-employee pTemplate="item">
                <span [title]="employee.Email">{{employee.FullName}}</span>
              </ng-template>
            </p-autoComplete>
            <span *ngIf="isUserSelected" class="section-Forerror">{{ 'TASK.KINDLY_ENTER_TASK_OWNER_NAME' | translate
              }}</span>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.TASK_PRE-WARNING_DAYS' | translate }}
              <span class="mandatory">*</span>
            </span>
            <input type="number" class="form-control inputWidth" maxlength="50" [(ngModel)]="Task.TaskPrewarningDays"
              [disabled]="!Task.IsActive || disableTask" required #preWarningDays="ngModel" />
            <span class="section-Forerror"
              *ngIf="preWarningDays.errors && (preWarningDays.dirty || preWarningDays.touched) && !preWarningDays.valid">
              Kindly Enter Task pre-warning days greater than or equal to 0
            </span>
            <span class="section-Forerror" *ngIf="preWarningDaysError">
              Kindly Enter Task pre-warning days greater than or equal to 0
            </span>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.START_DATE_THE_MATRIX' | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-calendar [(ngModel)]="defaultDate" dateFormat="dd/mm/yy" readonlyInput="true" monthNavigator="true"
              yearNavigator="true" yearRange="1950:2100" [showIcon]="true" [disabled]="!Task.IsActive || disableTask">
            </p-calendar>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.ACTION_OWNER' | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-autoComplete class="auto-complete" [(ngModel)]="Task.ActionOwner" [suggestions]="userResults"
              (completeMethod)="getUsersOnSearch($event)" (onSelect)="selectActionOwner($event)"
              (onChange)="selectActionOwner($event)" (onKeyUp)="resetPeoplePicker()" placeholder="Action Owner"
              field="FullName" [minLength]="1" appendTo="body" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}" [disabled]="!Task.IsActive || disableTask">
              <ng-template let-employee pTemplate="item">
                <span [title]="employee.Email">{{employee.FullName}}</span>
              </ng-template>
            </p-autoComplete>
            <span *ngIf="isOwnerSelected" class="section-Forerror">{{ 'TASK.KINDLY_ENTER_ACTION_OWNER' | translate
              }}</span>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.ACTION_PARTY' | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-autoComplete class="auto-complete" [(ngModel)]="Task.ActionParty" [suggestions]="userResults"
              (completeMethod)="getUsersOnSearch($event)" (onSelect)="selectActionParty($event)"
              (onChange)="selectActionParty($event)" (onKeyUp)="resetPeoplePicker()" placeholder="Action Party"
              field="FullName" [minLength]="1" appendTo="body" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}" [disabled]="!Task.IsActive || disableTask">
              <ng-template let-employee pTemplate="item">
                <span [title]="employee.Email">{{employee.FullName}}</span>
              </ng-template>
            </p-autoComplete>
            <span *ngIf="isPartySelected" class="section-Forerror">{{ 'TASK.KINDLY_ENTER_ACTION_PARTY' | translate
              }}</span>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ 'TASK.ACTION_VERIFIER' | translate }}
            </span>
            <p-autoComplete class="auto-complete" [(ngModel)]="Task.ActionVerifier" [suggestions]="userResults"
              (completeMethod)="getUsersOnSearch($event)" (onSelect)="selectActionVerifier($event)"
              (onChange)="selectActionVerifier($event)" (onKeyUp)="resetPeoplePicker()" placeholder="Action Verifier"
              field="FullName" [minLength]="1" appendTo="body" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}" [disabled]="!Task.IsActive || disableTask">
              <ng-template let-employee pTemplate="item">
                <span [title]="employee.Email">{{employee.FullName}}</span>
              </ng-template>
            </p-autoComplete>
            <span *ngIf="isVerifierSelected" class="section-Forerror">{{ 'TASK.KINDLY_ENTER_ACTION_VERIFIER' | translate
              }}</span>
          </div>
          <ara-category *ngIf="taskPermission.TSK_Admin || taskPermission.TSK_Admin_Unit" [moduleId]="moduleId"
            [sourceId]="taskId" [isActive]="isActive" [disabled]="disableTask"
            (categoryCheckedValueEmittedData)="categoryCheckedEmittedValue($event)">
          </ara-category>
          <ara-record-actions *ngIf="taskId>0" [SourceId]="taskId" ModuleName="Task"
            [ShowCancel]="((taskPermission.TSK_Admin || taskPermission.TSK_Admin_Unit || independentPermissions.SUPER_Admin) && Task.Status !=='Deleted') && Task.Status !=='Cancelled'"
            [ShowDelete]="independentPermissions.SUPER_Admin && Task.Status !=='Cancelled' && Task.Status !=='Deleted'" [Status]="Task.Status"
            [ShowRestate]="(taskPermission.TSK_Admin || taskPermission.TSK_Admin_Unit) && Task.Status==='Cancelled'"
            (output)="getOutput($event)"></ara-record-actions>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="breaker"></div>
      <footer>
        <button type="button" class="btn btn-primary primary-btn button-float-left button-back" (click)="navigateToOverview()">
          <i class="fa fa-check"></i> Back To Overview</button>
        <button type="button"
          *ngIf="Task.TaskId > 0"
          (click)="ReportshowDialog()"
          class="btn btn-primary primary-btn button-report-log button-float-left"
           >Report Log
        </button> 
          <button type="button" class="btn btn-primary primary-btn button-draft" (click)="saveAsDraft()"
          *ngIf="(Task.TaskId === 0 || Task.Status === 'Draft')">
					  <i class="fa fa-envelope"></i>Save As Draft</button>	
        <button *ngIf="taskId !== 0 && taskId" role="button" class="btn btn-primary primary-btn button-pdf"
          (click)="downloadPDF()">
          <i class="fa fa-file-pdf-o"></i>DOWNLOAD PDF
        </button>
        <button type="button" class="btn btn-primary primary-btn button-submit" *ngIf="(Task.TaskId === 0|| Task.Status === 'Draft')"
          (click)="submitTaskDetails()">
          <i class="fa fa-check"></i> Save</button>
        <button *ngIf="taskId !== 0 && taskId && Task.Status !== 'Draft' && Task.Status !== 'Cancelled' && Task.Status !== 'Deleted'" type="button" class="btn btn-primary primary-btn button-update"
          (click)="ConfirmUpdate()" [disabled]="!editEnabled || !isUpdateAllowed">
          <i class="fa fa-file-pdf-o"></i>Update
        </button> 
      </footer>
    </div>
  </div>
</div>
<ara-alerts [alertType]="alertType" [confirmMessage]="confirmMessage" [successDetails]="successDetails"
  [errorDetails]="errorDetails" (okClicked)="onOkClicked()" (yesClicked)="onYesClickedForConfirmation()"
  (noClicked)="onNoClickedForConfirmation()"></ara-alerts>

  <span *ngIf="ReportclosePopup">
    <p-dialog header="Report History" [(visible)]="ReportclosePopup" (onHide)="ReportclosePopUp()" [modal]="true">
     <ara-report-log [ReportUserId]="ReportUserId" [ReportModule]="ReportModule"
       [ReportRecordId]="ReportRecordId">
     </ara-report-log>
   </p-dialog> 
  </span> 

